import { TLevelStatusDto } from "@/api/services/main/curriculum-progress/dtos/get-curriculum-progress.dto";

/** True for either skip variant (pending or completed). */
export const isSkipStatus = (status: TLevelStatusDto): boolean => status === "skipped" || status === "skipped_completed";

/** True when the level counts as "done" for completion/progress-bar purposes. */
export const isLevelDoneStatus = (status: TLevelStatusDto): boolean => status === "completed" || isSkipStatus(status);
